import React, { Suspense, lazy } from 'react';
import { LOGO_BIG } from '../../common/images-s3';

const ImageLoader = lazy(() => import('../../common/image-loader'));


class ConnectionError extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            _props: this.props.data,
            /** test - delete */
            _props: { title: 'Oops, something went wrong', subtitle: 'Try refreshing the page, or try again later', linkText: 'REFRESH THE PAGE' }
            /** test */
        }

        this.onClickRedirect = this.onClickRedirect.bind(this);
    }

    onClickRedirect(e) {
        window.location.reload()  
        // window.reload  
        if (typeof this.state._props.linkURL !== 'undefined' && this.state._props.linkURL !== '') {
            this.props.history.push(this.state._props.linkURL);
        }
    }

    render() {

        return (
            <div className="page-error">
                <header>
                    <div className="container heading">
                        <Suspense fallback={null}>
                            <ImageLoader type="image" src={LOGO_BIG}></ImageLoader>
                        </Suspense>
                    </div>
                </header>
                <div className="c-error">
                    <div className="c-img">
                        <svg xmlns="http://www.w3.org/2000/svg" width="82.386" height="82.386" viewBox="0 0 82.386 82.386">
                            <g id="check" transform="translate(-17.6 -17.418)" opacity="0.3">
                                <path id="Subtraction_1" data-name="Subtraction 1" d="M38.691,77.386A38.7,38.7,0,0,1,23.632,3.04,38.7,38.7,0,0,1,53.751,74.346,38.445,38.445,0,0,1,38.691,77.386Zm0-69.686A31,31,0,0,0,26.628,67.251,31,31,0,1,0,38.691,7.7Z" transform="translate(20.1 19.918)" fill="#6f777c" stroke="#f8f9f9" strokeWidth="5" />
                                <line id="Line_234" data-name="Line 234" y2="29.087" transform="translate(59.425 39.448)" fill="none" stroke="#6f777c" strokeLinecap="round" strokeWidth="3" />
                                <line id="Line_235" data-name="Line 235" y2="0.052" transform="translate(59.425 77.335)" fill="none" stroke="#6f777c" strokeLinecap="round" strokeWidth="4" />
                            </g>
                        </svg>
                    </div>
                    <h3>{this.state._props.title}</h3>
                    <p>{this.state._props.subtitle}</p>
                    <button type="button" className="btn btn-dark" onClick={this.onClickRedirect}>{this.state._props.linkText}</button>
                </div>
            </div>
        )
    }
}

export default ConnectionError;